var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('el-input',_vm._b({attrs:{"size":"mini","value":_vm.value,"clearable":_vm.clearable},on:{"input":_vm.onInput,"change":_vm.onChange}},'el-input',_vm.$attrs,false)):_c('span',[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }